import React from 'react'
import { SvgIconColour } from 'components/Luxkit/SvgIcon'
import { getNavigationMenuIcon } from './utils'

interface Props {
  name: string;
  size?: number;
  type?: SvgIconColour
}

export function Icon(props: Props) {
  const { name, size = 48, type } = props
  const IconComponent = getNavigationMenuIcon(name)

  if (IconComponent) {
    return <IconComponent size={size} colour={type} />
  }

  return null
}

export default Icon
